// import Config from '@/global'
// import zh from './zh-CN.json'
import en from './en-US.json'
// if (Config.config.language === 'zh-cn') {
//   var language = zh
// } else {
//   language = en
// }
const language = en

export default language
